import HeroImageCta from './heroImageCta';

export default HeroImageCta;
